// ⚙️ Identidade do site num lugar só — pra trocar de novo, mexe AQUI e nos
// meta tags estáticos do public/index.html (marcados com "SITE_NAME" em
// comentário), e pronto.
export const SITE_NAME = "Sagaz";
// ⚠️ Ao lançar versão nova, bumpar AQUI e em public/version.json (mesmo valor).
// O app compara o version.json fresco do servidor com esta constante (que fica
// presa no bundle) — se diferirem, o navegador está servindo bundle velho do cache.
export const APP_VERSION = "2026.07.07";
export const SITE_URL = "https://assistente-estudos.pages.dev";
export const SITE_DESCRIPTION =
  "O tutor de IA que te conhece: aprende como você estuda, foca nas suas matérias fracas e ensina do seu jeito. Comece grátis.";
